/* eslint-disable import/prefer-default-export */
import { countries } from '../constants';
import convertToOption from '../utils/convert-to-option';

export const LANGUAGES = [
  'EN',
  'DE',
  'FR',
  'ES', // España
  'PL', // Polski
  // 'PT', // Português
  'IT', // Italiano
  'FI', // suomi
  'DA', // Dansk
  'NO', // Norsk
  'CS', // čeština
  'SK', // slovak
  'SV', // swedish
  'NL',
];

export const ORIGINS = [
  'Brand',
  'ZMS Creative In-House',
  'ZMS Creative Influencer',
];
export const IMAGE_TYPES = [
  'Single Model',
  'Multi Models',
  'Influencer Model',
  'Close Up',
  'Full Body Shot',
  'Location Image',
  'Studio Image',
  'Product Only Image',
  'Multi Products',
  'Single Product',
  'Brand Logo',
];

export const languageOptions = LANGUAGES.map(convertToOption);

export const originOptions = ORIGINS.map(convertToOption);

export const IMAGE = 'IMAGE';

export { genders as genderOptions } from '../quotes/constants';

export const imageTypeOptions = IMAGE_TYPES.map(convertToOption);

export const countryOptions = countries.map(c => c.label).map(convertToOption);

export const creativesTypes = {
  SC_CREATIVES: 'creatives',
  CONTENTFUL_CREATIVES: 'contentfulCreatives',
};

export const contentNameSelectLabel = object => {
  return `${object.content_name}`;
};
